<script setup>
const props = defineProps({
  image: Object,
  spacingBottom: {
    type: Boolean,
    default: false,
  },
  imageHasBorder: Boolean,
  imageFullWidth: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div :class="spacingBottom ? 'mb-xl' : ''">
    <div
      v-if="image"
      class="relative"
      :class="imageFullWidth ? '' : 'w-[90%] max-w-[600px] mx-auto'"
    >
      <div v-if="imageHasBorder" class="absolute inset-0 rounded-full z-0">
        <div
          class="absolute w-[84%] h-[84%] m-[8%] rounded-full bg-white"
        ></div>
      </div>
      <picture v-if="image" class="relative z-1">
        <source
          v-if="image.type !== 'svg' && image?.url?.webp"
          :srcset="image?.url?.webp"
          type="image/webp"
        />
        <source
          v-if="image.type !== 'svg' && image.type !== 'png' && image?.url?.jpg"
          :srcset="image?.url?.jpg"
          type="image/jpeg"
        />
        <img
          v-if="image.type === 'jpg' && image?.url?.jpg"
          class="block w-full"
          :src="image?.url?.jpg"
          :alt="image?.alt"
          :title="image?.title"
        />
        <img
          v-else-if="image.type === 'png' && image?.url?.png"
          class="block w-full"
          :src="image?.url?.png"
          :alt="image?.alt"
          :title="image?.title"
        />
        <img
          v-else
          class="block w-full"
          :src="image?.url?.original"
          :alt="image?.alt"
          :title="image?.title"
        />
      </picture>
    </div>
  </div>
</template>

<style></style>
